import { chartTimeSeconds, TIMEFRAME_SECONDS, chartTimeToCoordinate } from './chartTimeProjection.js'
import { SyncedCrosshairPrimitive } from './SyncedCrosshairPrimitive.js'
export { chartTimeSeconds } from './chartTimeProjection.js'
const DURATION = TIMEFRAME_SECONDS
const overlays = new WeakMap()
export function clearSyncedCrosshairOverlay(series) { overlays.get(series)?.set(null) }
function setOverlay(series, point, timeframe) {
  if (!series?.attachPrimitive) return
  let overlay = overlays.get(series)
  if (!overlay) { overlay = new SyncedCrosshairPrimitive(); overlays.set(series, overlay); series.attachPrimitive(overlay) }
  overlay.set(point, timeframe)
}

export function matchingCrosshairBar(bars, sourceTime, sourceTimeframe, targetTimeframe) {
  const source = chartTimeSeconds(sourceTime)
  if (source == null || !bars?.length) return null
  // A Daily/Weekly cursor represents a whole session/period. On a finer
  // chart, use its first available bar in that period, never an unrelated day.
  const coarseSource = (DURATION[sourceTimeframe] || 0) > (DURATION[targetTimeframe] || 0)
    && ['daily', 'weekly'].includes(sourceTimeframe)
  let low = 0
  let high = bars.length
  while (low < high) {
    const mid = (low + high) >>> 1
    if (chartTimeSeconds(bars[mid].time) < source) low = mid + 1
    else high = mid
  }
  if (coarseSource) {
    const bar = bars[low]
    return bar && chartTimeSeconds(bar.time) < source + DURATION[sourceTimeframe] ? bar : null
  }
  const exact = bars[low]
  if (exact && chartTimeSeconds(exact.time) === source) return exact
  const previous = bars[low - 1]
  const start = previous && chartTimeSeconds(previous.time)
  return previous && source < start + (DURATION[targetTimeframe] || 0) ? previous : null
}

export function applySyncedCrosshair(chart, series, point, timeframe, companions = []) {
  if (!chart || !series) return
  const allSeries = [series, ...companions.filter(Boolean)]
  allSeries.forEach(clearSyncedCrosshairOverlay)
  const bars = series.data()
  const outside = point?.projected && bars.length && (chartTimeSeconds(point.time) < chartTimeSeconds(bars[0].time) || chartTimeSeconds(point.time) > chartTimeSeconds(bars.at(-1).time))
  const bar = point && !outside && matchingCrosshairBar(bars, point.time, point.timeframe, timeframe)
  const x = point && (bar ? chart.timeScale().timeToCoordinate(bar.time) : chartTimeToCoordinate(chart, series, point.time, timeframe))
  if (!point || x == null || x < 0 || x > chart.timeScale().width()) {
    chart.clearCrosshairPosition()
    return
  }
  if (!bar) {
    chart.clearCrosshairPosition()
    setOverlay(series, point, timeframe)
    companions.filter(Boolean).forEach(peer => setOverlay(peer, { ...point, price: undefined }, timeframe))
    return
  }
  const price = Number.isFinite(point.price) ? point.price : bar.close ?? bar.value
  if (!Number.isFinite(price)) {
    chart.clearCrosshairPosition()
    return
  }
  chart.setCrosshairPosition(price, bar.time, series)
}
